export default "__VITE_ASSET__CL2EVZ4___"